import { FC, JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { StylesConfig } from '@player/content';

import BoldIcon from '@/shared/ui/icons/svgs/24/bold.svg?react';
import ItalicIcon from '@/shared/ui/icons/svgs/24/italic.svg?react';

import PositionSwitcher from './PositionSwitcher';
import ToggleButton from './ToggleButton';

interface ISettingsProps {}

const Settings: FC<ISettingsProps> = (): JSX.Element => {
  const { control } = useFormContext<{ config: StylesConfig }>();

  return (
    <div className="flex gap-2">
      <div className="flex grow flex-col gap-2">
        <div className="flex grow text-sm font-semibold">Text style</div>
        <div className="flex gap-2">
          <Controller
            control={control}
            name="config.text.bold"
            render={({ field: { value, onChange: controllerOnChange } }) => (
              <ToggleButton
                Icon={BoldIcon}
                tooltip="Bold"
                active={!!value}
                onChange={controllerOnChange}
              />
            )}
          />
          <Controller
            control={control}
            name="config.text.italic"
            render={({ field: { value, onChange: controllerOnChange } }) => (
              <ToggleButton
                Icon={ItalicIcon}
                tooltip="Italic"
                active={!!value}
                onChange={controllerOnChange}
              />
            )}
          />
        </div>
      </div>
      <div className="flex grow flex-col gap-2">
        <div className="flex grow text-sm font-semibold">Text position</div>
        <div className="flex gap-2">
          <Controller
            control={control}
            name="config.text.position"
            render={({ field: { value, onChange: controllerOnChange } }) => (
              <PositionSwitcher
                position={value}
                onChange={controllerOnChange}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default Settings;
